module.exports = __webpack_public_path__ + "img/left1@2x.74a993a4.png";